var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 py-1 px-0"},[(_vm.loading)?_c('load',{attrs:{"mode":"table"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.historicos),function(historico){return _c('div',{key:historico.id,staticClass:"card card-body table table-sm bg-white border-4 border-bottom border-primary"},[(historico.new_values)?_c('div',[_c('div',{staticClass:"row py-2",staticStyle:{"border-bottom":"2px solid #007bff !important"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('b',[_vm._v("ABA:")]),_vm._v("\n          "+_vm._s(historico.auditable_type
              .replace("Modules\\Acolhimento\\Entities\\Acolhimento", "")
              .replace(
                "DadoJuridicos",
                "Documentação/Identificação Processual"
              )
              .replace("Profissionalizacao", "Profissionalização")
              .replace("PrimeiraObservacao", "Primeira Observação")
              .replace("Crianca", "Detalhes do Acolhimento")
              .replace("Educacao", "Educação")
              .replace("CaractSaude", "Saúde e Desenvolvimento")
              .replace("DinamicaFamiliar", "Tipo de vínculo")
              .replace(
                "MetaResponsavel",
                "Objetivos e Metas - Pais e responsáveis"
              )
              .replace(
                "MetaDetalhes do Acolhimento",
                "Objetivos e Metas - Criança e Adolescente"
              ))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('b',[_vm._v("DATA DE REGISTRO:")]),_vm._v("\n          "+_vm._s(_vm._f("moment")(historico.created_at,"DD/MM/YYYY H:mm"))),_c('br'),_vm._v(" "),_c('b',[_vm._v("EVENTO:")]),_vm._v(" "+_vm._s(historico.event)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('b',[_vm._v("RESPONSÁVEL PELA EDIÇÃO:")]),_vm._v(" "+_vm._s(historico.tecnico.nome)+" -\n          "),_c('small',[_vm._v(_vm._s(historico.tecnico.unidade.nome)+" ")])])]),_vm._v(" "),(historico.new_values.arte_meta)?_c('b',[_vm._v("ARTE META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.arte_meta)}}),_vm._v(" "),(historico.new_values.arte_situacao_atual)?_c('b',[_vm._v("ARTE SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.arte_situacao_atual)}}),_vm._v(" "),(historico.new_values.aspecto_meta)?_c('b',[_vm._v("ASPECTO META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.aspecto_meta)}}),_vm._v(" "),(historico.new_values.aspecto_situacao_atual)?_c('b',[_vm._v("ASPECTO SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.aspecto_situacao_atual)}}),_vm._v(" "),(historico.new_values.condicao_meta)?_c('b',[_vm._v("CONDIÇÃO META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.condicao_meta)}}),_vm._v(" "),(historico.new_values.aspecto_situacao_atual)?_c('b',[_vm._v("CONDIÇÃO SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.condicao_situacao_atual)}}),_vm._v(" "),(historico.new_values.desligamento_meta)?_c('b',[_vm._v("DESLIGAMENTO META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.desligamento_meta)}}),_vm._v(" "),(historico.new_values.desligamento_situacao_atual)?_c('b',[_vm._v("DESLIGAMENTO SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.desligamento_situacao_atual)}}),_vm._v(" "),(historico.new_values.documental_meta)?_c('b',[_vm._v("DOCUMENTAL META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.documental_meta)}}),_vm._v(" "),(historico.new_values.documental_situacao_atual)?_c('b',[_vm._v("DOCUMENTAL SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.documental_situacao_atual)}}),_vm._v(" "),(historico.new_values.educacao_meta)?_c('b',[_vm._v("EDUCAÇÃO META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.educacao_meta)}}),_vm._v(" "),(historico.new_values.educacao_situacao_atual)?_c('b',[_vm._v("EDUCAÇÃO SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.educacao_situacao_atual)}}),_vm._v(" "),(historico.new_values.processual_meta)?_c('b',[_vm._v("PROCESSUAL META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.processual_meta)}}),_vm._v(" "),(historico.new_values.processual_situacao_atual)?_c('b',[_vm._v("PROCESSUAL SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.processual_situacao_atual)}}),_vm._v(" "),(historico.new_values.profissionalizacao_meta)?_c('b',[_vm._v("PROFISSIONALIZAÇÃO META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.profissionalizacao_meta)}}),_vm._v(" "),(historico.new_values.profissionalizacaol_situacao_atual)?_c('b',[_vm._v("PROFISSIONALIZAÇÃO SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.profissionalizacao_situacao_atual)}}),_vm._v(" "),(historico.new_values.relacao_meta)?_c('b',[_vm._v("RELAÇÃO META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.relacao_meta)}}),_vm._v(" "),(historico.new_values.relacao_situacao_atual)?_c('b',[_vm._v("RELAÇÃO SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.relacao_situacao_atual)}}),_vm._v(" "),(historico.new_values.saude_meta)?_c('b',[_vm._v("SAUDÊ META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.saude_meta)}}),_vm._v(" "),(historico.new_values.saude_situacao_atual)?_c('b',[_vm._v("SAUDÊ SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.saude_situacao_atual)}}),_vm._v(" "),(historico.new_values.vulnerabildiade_meta)?_c('b',[_vm._v("VULNERABILIDADE META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.vulnerabildiade_meta)}}),_vm._v(" "),(historico.new_values.vulnerabildiade_situacao_atual)?_c('b',[_vm._v("VULNERABILIDADE SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.vulnerabildiade_situacao_atual)}}),_vm._v(" "),(historico.new_values.autonomia_meta)?_c('b',[_vm._v("AUTONOMIA META:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.autonomia_meta)}}),_vm._v(" "),(historico.new_values.autonomiae_situacao_atual)?_c('b',[_vm._v("AUTONOMIA SITUAÇÃO ATUAL:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(historico.new_values.autonomia_situacao_atual)}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.horario, 'HORÁRIO'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.salario, 'SALÁRIO'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.protocolo, 'PROTOCOLO'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.cadastrado, 'CADASTRADO'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.responsavel,
            'TÉCNICO RESPONSÁVEL',
            'name'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.unidade,
            'UNIDADE DO RESPONSÁVEL',
            'nome'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.outros_tecnicos,
            'OUTRO(S) TÉCNICO(S)',
            null,
            true
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.tipo, 'TIPO DE ATENDIMENTO'))}}),_vm._v(" "),(historico.new_values.tipo == 'ABORDAGEM SOCIAL')?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.situacao_abordagem_social_nomes,
            'SITUAÇÕES IDENTIFICADAS NA ABORDAGEM SOCIAL'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.outra_situacao_abordagem_social,
            'OUTRAS SITUAÇÕES IDENTIFICADAS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.status_nome, 'STATUS'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.privado,
            'SIGILO',
            null,
            false,
            true,
            ['1', 'Sim', 'Não']
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row"},[(historico.new_values.familia)?_c('div',{staticClass:"col-12"},[_c('b',[_vm._v("USUÁRIO(S) ATENDIDO(S):")]),_vm._v(" "),_vm._l((historico.new_values.pessoas),function(pessoa,index){return _c('b',{key:pessoa.id,staticClass:"mr-2 badge badge-default"},[_vm._v("\n            "+_vm._s(pessoa.nome_completo)+"\n          ")])}),_vm._v(" "),(
              historico.new_values.familia.rf_situacao_rua != null &&
              historico.new_values.familia.rf_situacao_rua.status == 1
            )?_c('small',{staticClass:"badge badge-danger my-2"},[_vm._v("RF registrado em Situação de Rua no Sistema")]):_vm._e()],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.tipo_servico_id,
              _vm.servicos
            ),
            'SERVIÇO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.local, 'LOCAL'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.assessoramento_juridico,
              _vm.$root.arrays.assessoramento_juridico
            ),
            'ASSESSORAMENTO JURÍDICO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.reincidencia,
              _vm.$root.arrays.reincidencia
            ),
            'REINCIDÊNCIA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.ato_inflacional,
              _vm.$root.arrays.ato_inflacional
            ),
            'ATO INFRACIONAL'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.registro_carteira,
              _vm.$root.arrays.pergunta
            ),
            'REGISTRO EM CARTEIRA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.estudo_acompanhamento,
              _vm.$root.arrays.pergunta
            ),
            'EM ESTUDO E ACOMPANHAMENTO DA SITUAÇÃO FAMILIAR'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.crianca_orfao,
              _vm.$root.arrays.pergunta
            ),
            'CRIANÇA/ADOLESCENTE ÓRFÃO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.intereressados_acolher,
              _vm.$root.arrays.pergunta
            ),
            'ENTRE OS PARENTES IDENTIFICADOS, HÁ INTERESSADOS EM ACOLHER A CRIANÇA/ADOLESCENTE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.condicao_higiene,
              _vm.$root.arrays.pergunta
            ),
            'A CRIANÇA/ADOLESCENTE ENCONTRAVA-SE EM BOAS CONDIÇÕES DE HIGIENE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.chegou_agitada,
              _vm.$root.arrays.pergunta
            ),
            'A CRIANÇA/ADOLESCENTE ESTAVA AGITADA AO CHEGAR NA UNIDADE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.chegou_chorando,
              _vm.$root.arrays.pergunta
            ),
            'A CRIANÇA/ADOLESCENTE ESTAVA CHORANDO AO CHEGAR NA UNIDADE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.dificuldade_dormir,
              _vm.$root.arrays.pergunta
            ),
            'A CRIANÇA/ADOLESCENTE APRESENTOU DIFICULDADE PARA DORMIR'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.enurese_noturna,
              _vm.$root.arrays.pergunta
            ),
            'A CRIANÇA/ADOLESCENTE APRESENTOU ENURESE NOTURNA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.vestigio_psicoativo,
              _vm.$root.arrays.pergunta
            ),
            'A CRIANÇA ADOLESCENTE APRESENTAVA VESTÍGIOS DO USO DE ALGUMA SUBSTÂNCIA PSICOATIVA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.violencia_fisica,
              _vm.$root.arrays.pergunta
            ),
            'A CRIANÇA ADOLESCENTE APRESENTAVA ALGUM SINAL DE VIOLÊNCIA FÍSICA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.violacia_sexual,
              _vm.$root.arrays.pergunta
            ),
            'A CRIANÇA ADOLESCENTE APRESENTAVA ALGUM SINAL DE VIOLÊNCIA SEXUAL'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.vivencia_negligencia,
              _vm.$root.arrays.pergunta
            ),
            'A CRIANÇA ADOLESCENTE APRESENTAVA ASPECTOS QUE INDICAM A VIVÊNCIA DE NEGLIGÊNCIA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.aspectos_pessoais,
              _vm.$root.arrays.acolhimento_aspectos_pessoais
            ),
            'ASPECTOS PESSOAIS OBSERVADOS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.unidade_acolhimento_proxima,
              _vm.$root.arrays.pergunta
            ),
            'A UNIDADE DE ACOLHIMENTO LOCALIZA-SE PRÓXIMO À RESIDÊNCIA DOS PAIS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.residia_familia_origem,
              _vm.$root.arrays.pergunta
            ),
            'NO MOMENTO DO ACOLHIMENTO RESIDIA COM A FAMÍLIA DE ORIGEM'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.preparacao_reintegracao_natural,
              _vm.$root.arrays.pergunta
            ),
            'PREPARAÇÃO PARA REINTEGRAÇÃO FAMILIAR (FAMÍLIA NATURAL)'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.preparacao_reintegracao_extensa,
              _vm.$root.arrays.pergunta
            ),
            'PREPARAÇÃO PARA REINTEGRAÇÃO FAMILIAR (FAMÍLIA EXTENSA)'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.poder_fam_destituido,
              _vm.$root.arrays.pergunta
            ),
            'PODER FAMILIAR DESTITUÍDO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.processo_guarda,
              _vm.$root.arrays.pergunta
            ),
            'EM PROCESSO DE GUARDA/TUTELA/ADOÇÃO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.sem_informacao,
              _vm.$root.arrays.pergunta
            ),
            'SEM INFORMAÇÃO DA FAMÍLIA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.experiencia_anterior,
              _vm.$root.arrays.pergunta
            ),
            'EXPERIÊNCIAS ANTERIORES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.participou_cursos,
              _vm.$root.arrays.pergunta
            ),
            'JÁ PARTICIPOU DE CURSOS PROFISSIONALIZANTES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.pronuncia_correta,
              _vm.$root.arrays.pergunta
            ),
            'PRONUNCIA CORRETAMENTE AS PALAVRAS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.troca_letra,
              _vm.$root.arrays.pergunta
            ),
            'TROCA LETRAS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.omite_letras,
              _vm.$root.arrays.pergunta
            ),
            'OMITE LETRAS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.compreende_perguntas,
              _vm.$root.arrays.pergunta
            ),
            'COMPREENDE PERGUNTAS QUE LHE SÃO FEITAS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.gagueira,
              _vm.$root.arrays.pergunta
            ),
            'APRESENTA GAGUEIRAS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.apetite,
              _vm.$root.arrays.pergunta
            ),
            'TEM BOM APETITE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.alergia_alimento,
              _vm.$root.arrays.pergunta
            ),
            'TEM ALERGIA A ALGUM ALIMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.recusa_alimentar,
              _vm.$root.arrays.pergunta
            ),
            'RECUSA ALIMENTAÇÃO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.ajuda_alimentar,
              _vm.$root.arrays.pergunta
            ),
            'NECESSITA DE AJUDA PARA SE ALIMENTAR'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.cartao_vacina,
              _vm.$root.arrays.pergunta
            ),
            'POSSUI CARTÃO DE VACINA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.cartao_atualizado,
              _vm.$root.arrays.pergunta
            ),
            'O CARTÃO ESTÁ ATUALIZADO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.estabanada,
              _vm.$root.arrays.pergunta
            ),
            'É DESASTRADA/DESATENCIOSA (ESBARRA NOS MÓVEIS, DERRUBA ÁGUA OU COMIDA NA MESA)'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.problema_ortopedico,
              _vm.$root.arrays.pergunta
            ),
            'APRESENTA ALGUM PROBLEMA ORTOPÉDICO (PÉ CHATO, TORTO ETC.)'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.aproxima_objetos,
              _vm.$root.arrays.pergunta
            ),
            'APROXIMA MUITO OS OBJETOS PARA VÊ-LOS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.aperta_olhos,
              _vm.$root.arrays.pergunta
            ),
            'APERTA OS OLHOS PARA OLHAR À DISTÂNCIA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.inflamacao_ouvidos,
              _vm.$root.arrays.pergunta
            ),
            'COSTUMA TER INFLAMAÇÕES NOS OUVIDOS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.reacao_ruidos,
              _vm.$root.arrays.pergunta
            ),
            'APRESENTA REAÇÕES DIFERENTES A RUÍDOS DIFERENTES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.reacao_cheiros,
              _vm.$root.arrays.pergunta
            ),
            'APRESENTA ALGUMA REAÇÃO ESPECIAL A DIFERENTES TIPOS DE CHEIRO E GOSTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.tomou_vacinas,
              _vm.$root.arrays.pergunta
            ),
            'TOMOU AS VACINAS NECESSÁRIAS CONFORME A IDADE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.doencas_infantis,
              _vm.$root.arrays.pergunta
            ),
            'QUE DOENÇAS INFANTIS JÁ TEVE'
          )
        )}}),_vm._v(" "),(historico.new_values.doencas_infantis == 5)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.doencas_outras,
              _vm.$root.arrays.pergunta
            ),
            'QUAIS OUTRAS DOENÇAS'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.alergia,
              _vm.$root.arrays.pergunta
            ),
            'TEM ALERGIAS'
          )
        )}}),_vm._v(" "),(historico.new_values.alergia == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.alergia_a_que,
              _vm.$root.arrays.pergunta
            ),
            'A QUE'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.sofreu_acidente,
              _vm.$root.arrays.pergunta
            ),
            'JÁ SOFREU ALGUM ACIDENTE OU QUEDA'
          )
        )}}),_vm._v(" "),(historico.new_values.sofreu_acidente == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.como_reagiu_acidente,
              _vm.$root.arrays.pergunta
            ),
            'COMO REAGIU'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.encaminhar_atendimento_medico == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.atendimento_medico_quais, 'QUAIS')
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.sexualidade_compativel_idade == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.sexualidade_compativel_porque,
            'POR QUE'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.apresenta_tique == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.tique_descricao, 'DESCREVA'))}}):_vm._e(),_vm._v(" "),(historico.new_values.irrita_facil == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.reage_frustacao,
            'COMO REAGE QUANDO FRUSTRADO'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.expressa_emocoes,
            'COMO EXPRESSA SUAS EMOÇÕES? (É ESPONTÂNEO NOS AFETOS, TOLHIDO, FOGE DOS CONTATOS)'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.reage_raiva,
            'COMO REAGE QUANDO TEM RAIVA? (ISOLA - SE, TORNA-SE AGRESSIVO)'
          )
        )}}),_vm._v(" "),(historico.new_values.medo == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.medo_de_que, 'QUAIS'))}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.cuidado_especial,
              _vm.$root.arrays.pergunta
            ),
            'PRECISA DE ALGUM CUIDADO ESPECIAL POR MOTIVO DE SAÚDE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.chora_frequente,
              _vm.$root.arrays.pergunta
            ),
            'CHORA FREQUENTEMENTE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.necessita_disciplina,
              _vm.$root.arrays.pergunta
            ),
            'ACEITA SER DISCIPLINADO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.respeita_autoridade,
              _vm.$root.arrays.pergunta
            ),
            'RESPEITA A FIGURA DA AUTORIDADE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.aproximacao_pai,
              _vm.$root.arrays.pergunta
            ),
            'TEM BOA APROXIMAÇÃO COM O PAI'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.aproximacao_mae,
              _vm.$root.arrays.pergunta
            ),
            'TEM BOA APROXIMAÇÃO COM A MÃE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.preferencia_genitores,
              _vm.$root.arrays.pergunta
            ),
            'MOSTRA PREFERÊNCIA POR UM DOS GENITORES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.bem_entre_irmaos,
              _vm.$root.arrays.pergunta
            ),
            'SENTE-SE BEM ENTRE OS IRMÃOS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.relacao_boa_acolidos,
              _vm.$root.arrays.pergunta
            ),
            'RELACIONA-SE BEM COM OS OUTROS ACOLHIDOS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.relacao_boa_funcionarios,
              _vm.$root.arrays.pergunta
            ),
            'RELACIONA-SE BEM COM OS FUNCIONÁRIOS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.brinca,
              _vm.$root.arrays.pergunta
            ),
            'GOSTA DE BRINCAR'
          )
        )}}),_vm._v(" "),(historico.new_values.preferencia_genitores == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.preferencia_genitores_motivo,
            'POR QUAL MOTIVO'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.chupeta,
              _vm.$root.arrays.pergunta
            ),
            'USA CHUPETA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.brinca_com_pessoas,
              _vm.$root.arrays.pergunta
            ),
            'BRINCA COM PESSOAS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.interrupcao_estudos,
              _vm.$root.arrays.pergunta
            ),
            'HOUVE INTERRUPÇÃO NOS ESTUDOS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.dificuldade_aprendizagem,
              _vm.$root.arrays.pergunta
            ),
            'APRESENTA DIFICULDADE DE APRENDIZAGEM'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.frequenta_programa_social,
              _vm.$root.arrays.pergunta
            ),
            'FREQUENTA PROGRAMAS SOCIAIS – CONTRA TURNO ESCOLAR'
          )
        )}}),_vm._v(" "),(historico.new_values.frequenta_programa_social == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.unidade_programa_social,
            'QUAL A UNIDADE'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.metodo_aprendizagem,
            'QUAL MÉTODO DE ENSINO TERIA MAIOR FACILIDADE DE APRENDIZAGEM EM RAZÃO DO SEU PERFIL COMPORTAMENTAL'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.consideracao_escolar,
            'CONSIDERAÇÕES SOBRE A VIDA ESCOLAR (FREQUÊNCIA,COMPORTAMENTO, APRENDIZAGEM)'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.local, 'QUAL O LOCAL DO TRABALHO')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.numero_processo, 'NÚMERO DO PROCESSO')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.numero_guia_acolhimento,
            'NÚMERO DA GUIA DE ACOLHIMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.numero_guia_desligamento,
            'NÚMERO DA GUIA DE DESLIGAMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.nome_tribunal, 'NOME DO TRIBUNAL')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.nome_comarca, 'NOME DA COMARCA')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.nome_responsavel_caso,
            'NOME DA VARA ESPECIALIZADA RESPONSÁVEL PELO CASO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.endereco_vara,
            'ENDEREÇO DA VARA ESPECIALIZADA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.pessoa_referencia_vara,
            'PESSOA DE REFERÊNCIA NA VARA ESPECIALIZADA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.horario, 'QUAL O HORÁRIO'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.salario, 'SALÁRIO'))}}),_vm._v(" "),(historico.new_values.participou_cursos == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.qual_curso,
            'QUAIS CURSOS PROFISSIONALIZANTES'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.gostaria_participar == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.quais_cursos_gostaria_participar,
            'QUAIS CURSOS GOSTARIA DE PARTICIPAR'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.solicitante == 4)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.solicitante_outros, 'OUTRO'))}}):_vm._e(),_vm._v(" "),(historico.new_values.possui_irmao_unidade == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.quant_irmao_unidade, 'QUANTOS'))}}):_vm._e(),_vm._v(" "),(
          historico.new_values.motivo == 19 ||
          historico.new_values.motivo == 18
        )?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.motivo_outros,
            'ESPECIFIQUE OUTROS OU NEGLIGÊNCIA'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.termo_acolhimento,
            'TERMO DE ACOLHIMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.data_acolhimento,
            'DATA DO ACOLHIMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.hora_acolhimento,
            'HORA DO ACOLHIMENTO'
          )
        )}}),_vm._v(" "),(historico.new_values.medida_nome_unidade)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.medida_nome_unidade,
            'NOME DA UNIDADE'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.medida_endereco)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.medida_endereco,
            'ENDEREÇO DA UNIDADE'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.medida_data_entrada)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.medida_data_entrada,
            'DATA DE ENTRADA'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.medida_data_saida)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.medida_data_saida, 'DATA DE SAÍDA')
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.medida_motivo)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.medida_motivo,
            'MOTIVO DO ACOLHIMENTO'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.medida_motivo_desligamento)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.medida_motivo_desligamento,
            'MOTIVO DO DESLIGAMENTO'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.nome_parentesco_guarda)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.nome_parentesco_guarda,
            'NOME E PARENTESCO DA PESSOA QUE ASSUMIU A GUARDA APÓS O DESLIGAMENTO'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.autores_violencia_violacao_outro)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.autores_violencia_violacao_outro,
            'QUAL'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.motivo,
              _vm.$root.arrays.acolhimento_motivo
            ),
            'MOTIVO(S) DO ACOLHIMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.autores_violencia_violacao,
              _vm.$root.arrays.autores_violencia_violacao
            ),
            'CONSIDERANDO OS MOTIVOS DO ACOLHIMENTO, INFORME QUEM É / OU SÃO O(S) SUPOSTO(S) AUTOR(ES) DA VIOLÊNCIA/VIOLAÇÃO DE DIREITOS OU RESPONSÁVEL(IS) QUE ESTÁ(ÃO) IMPOSSIBILITADO(S) DE PRESTAR OS CUIDADOS E PROTEÇÃO NECESSÁRIOS À CRIANÇA/ADOLESCENTE'
          )
        )}}),_vm._v(" "),(historico.new_values.impedimento_judicial == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.autores_violencia_violacao_outro,
              _vm.$root.arrays.pergunta
            ),
            'SE SIM, INDIQUE AS PESSOAS IMPEDIDAS (APERTE ENTER, PARA INSERIR UMA OU MAIS PESSOAS)'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.medidas_antes_acolhimento == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.pessoas_impedidas,
              _vm.$root.arrays.pergunta
            ),
            'REGISTRO EM CARTEIRA'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.medidas_antes_aplicadas,
              _vm.$root.arrays.medidas_antes_aplicadas
            ),
            'QUAL'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.medidas_antes_acolhimento,
              _vm.$root.arrays.pergunta
            ),
            'FORAM APLICADAS OUTRAS MEDIDAS DE PROTEÇÃO ANTES DO ACOLHIMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.impedimento_judicial,
              _vm.$root.arrays.pergunta
            ),
            'HÁ IMPEDIMENTO JUDICIAL QUE IMPEÇA O CONTATO DOS PAIS/RESPONSÁVEIS COM A CRIANÇA/ADOLESCENTE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.crianca_cadastro_desaparecida,
              _vm.$root.arrays.pergunta
            ),
            'CRIANÇA/ ADOLESCENTE INCLUÍDO NO CADASTRO NACIONAL DA CRIANÇA OU ADOLESCENTE DESAPARECIDO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.crianca_cadastro_adocao,
              _vm.$root.arrays.pergunta
            ),
            'CRIANÇA/ADOLESCENTE ESTÁ INCLUÍDO NO CADASTRO NACIONAL DE ADOÇÃO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.cumprimento_medidas,
              _vm.$root.arrays.pergunta
            ),
            'ADOLESCENTE CUMPRINDO MEDIDA SOCIOEDUCATIVA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.acolhido_anteriomente,
              _vm.$root.arrays.pergunta
            ),
            'CRIANÇA/ADOLESCENTE FOI ACOLHIDA ANTERIORMENTE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.medida_protetiva_aplicada,
              _vm.$root.arrays.medida_protetiva_aplicada
            ),
            'MEDIDA PROTETIVA DE ACOLHIMENTO INSTITUCIONAL APLICADA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.deseja_alguma_profissao,
              _vm.$root.arrays.pergunta
            ),
            'DESEJA SEGUIR ALGUMA PROFISSÃO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.possui_irmao_unidade,
              _vm.$root.arrays.pergunta
            ),
            'POSSUI IRMÃO NA UNIDADE DE ACOLHIMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.solicitante,
              _vm.$root.arrays.acolhimento_solicitantes
            ),
            'SOLICITAÇÃO DE VAGA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.qual_profissao_interesse,
              _vm.$root.ocupacoes
            ),
            'QUAL DAS PROFISSÕES, DE ACORDO COM A CLASSIFICAÇÃO BRASILEIRA DE OCUPAÇÕES, TEM INTERESSE DE SEGUIR'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.observacoes,
            'OBSERVAÇÃO SOBRE AS COMPETÊNCIAS PROFISSIONAIS IDENTIFICADAS/APTIDÕES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.experiencia_anterior,
              _vm.$root.arrays.pergunta
            ),
            'EXPERIÊNCIAS ANTERIORES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.gostaria_participar,
              _vm.$root.arrays.pergunta
            ),
            'GOSTARIA DE PARTICIPAR DE CURSOS PROFISSIONALIZANTES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.participou_cursos,
              _vm.$root.arrays.pergunta
            ),
            'JÁ PARTICIPOU DE CURSOS PROFISSIONALIZANTES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.irrita_facil,
              _vm.$root.arrays.pergunta
            ),
            'IRRITA-SE FACILMENTE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.trabalhando,
              _vm.$root.arrays.pergunta
            ),
            'ESTÁ TRABALHANDO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.medo,
              _vm.$root.arrays.pergunta
            ),
            'DEMONSTROU MEDO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.roi_unha,
              _vm.$root.arrays.pergunta
            ),
            'RÓI UNHAS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.chupa_dedo,
              _vm.$root.arrays.pergunta
            ),
            'CHUPA DEDO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.apresenta_tique,
              _vm.$root.arrays.pergunta
            ),
            'APRESENTA ALGUM TIQUE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.sexualidade_compativel_idade,
              _vm.$root.arrays.pergunta
            ),
            'SUA SEXUALIDADE É COMPATÍVEL COM A IDADE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.ind_acompanhamento_psicologico,
              _vm.$root.arrays.pergunta
            ),
            'HÁ INDICAÇÃO PARA ACOMPANHAMENTO PSICOLÓGICO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.ja_acompanhamento_psicologico,
              _vm.$root.arrays.pergunta
            ),
            'JÁ PASSOU POR ACOMPANHAMENTO PSICOLÓGICO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.encaminhar_atendimento_medico,
              _vm.$root.arrays.pergunta
            ),
            'É NECESSÁRIO ENCAMINHAMENTO PARA ATENDIMENTO MÉDICO ESPECIALIZADO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.uso_prolongado_medicamento,
              _vm.$root.arrays.pergunta
            ),
            'FAZ USO CONSTANTE OU PROLONGADO DE MEDICAMENTOS'
          )
        )}}),_vm._v(" "),(historico.new_values.uso_prolongado_medicamento == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.uso_medicamento_quais,
            'QUAIS MEDICAMENTOS'
          )
        )}}):_vm._e(),_vm._v(" "),(historico.new_values.uso_prolongado_medicamento == 1)?_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.uso_medicamento_periodo,
            'QUAL PERÍODO MEDICAMENTOS'
          )
        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.metas_pia,
              _vm.$root.arrays.metas_pia
            ),
            'AS METAS E OBJETIVOS ESTABELECIDAS NO PIA FORAM ALCANÇADOS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.cumpriu_condicionalidade,
              _vm.$root.arrays.cumpriu_condicionalidade
            ),
            'O ADOLESCENTE CUMPRIU COM AS CONDICIONALIDADES ESTABELECIDAS NO TERMO DE COMPROMISSO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.disponibilidade_adolescente,
              _vm.$root.arrays.medidas_avaliacao
            ),
            'SOBRE A DISPONIBILIDADE DO ADOLESCENTE PARA REALIZAR AS ATIVIDADES PROPOSTAS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.pontualidade,
              _vm.$root.arrays.medidas_avaliacao
            ),
            'PONTUALIDADE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.sociabilidade,
              _vm.$root.arrays.medidas_avaliacao
            ),
            'SOCIABILIDADE COM A EQUIPE E NO LOCAL DE PRESTAÇÃO DA MEDIDA'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.participacao_cumprimento,
              _vm.$root.arrays.medidas_avaliacao
            ),
            'A PARTICIPAÇÃO DA FAMÍLIA NO PROCESSO DE CUMPRIMENTO DA MEDIDA PELO ADOLESCENTE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.participacao_cumprimento,
              _vm.$root.arrays.medidas_avaliacao
            ),
            'A PARTICIPAÇÃO DA FAMÍLIA NO PROCESSO DE CUMPRIMENTO DA MEDIDA PELO ADOLESCENTE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.participacao_planejamento,
              _vm.$root.arrays.medidas_avaliacao
            ),
            'PARTICIPAÇÃO NO PLANEJAMENTO DO SEU CRONOGRAMA DE ATIVIDADES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.documentos_recebidos,
              _vm.$root.arrays.documentos_recebidos
            ),
            'DOCUMENTOS RECEBIDOS REFERENTE A MSE EM EXECUÇÃO E EXECUÇÕES ANTERIORES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.trabalhando,
              _vm.$root.arrays.pergunta
            ),
            'ESTÁ TRABALHANDO?'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.gostaria_participar,
              _vm.$root.arrays.pergunta
            ),
            'GOSTARIA DE PARTICIPAR DE CURSOS PROFISSIONALIZANTES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            _vm.verificarValueArray(
              historico.new_values.deseja_alguma_profissao,
              _vm.$root.arrays.pergunta
            ),
            'DESEJA SEGUIR ALGUMA PROFISSÃO?'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.quais_cursos_gostaria_participar,
            'QUAIS CURSOS GOSTARIA DE PARTICIPAR'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.qual_curso,
            'QUAIS CURSOS PROFISSIONALIZANTES'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.planos_futuro, 'PLANOS FUTUROS')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.recebe_influencia_negativa,
            'O ADOLESCENTE RECEBE ALGUM TIPO DE INFLUÊNCIA NEGATIVA EM RELAÇÃO AOS INTERESSES E PLANOS PARA O FUTURO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.recebe_apoio,
            'O ADOLESCENTE RECEBE ALGUM TIPO DE  APOIO OU ACOLHIMENTO EM RELAÇÃO AOS INTERESSES E PLANOS PARA O FUTURO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.familia_corresponde,
            'A FAMILIA CORRESPONDE A ESTE INTERESSE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.familia_corresponde,
            'A FAMILIA CORRESPONDE A ESTE INTERESSE'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.observacoes, 'OBSERVAÇÃO'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.outros_documentos,
            'OUTROS DOCUMENTOS'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.numero, 'NÚMERO'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.autos, 'AUTOS Nº'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.outra_unidade_id, 'OUTRA UNIDADE')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.outra_unidade, 'OUTRA UNIDADE'))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.data_prevista_formatado,
            'DATA DO AGENDAMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.hora_prevista_formatado,
            'HORA DO AGENDAMENTO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.descricao_sumaria, 'OBSERVAÇÃO')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.processo_data_final,
            'DATA FINAL PROCESSO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.processo_data_inicial,
            'DATA INICIAL PROCESSO'
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.acomp_data_final,
            'DATA FINAL ACOMPANHAMENTO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.acomp_data_inicial,
            'DATA INICIAL ACOMPANHAMENTO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.documental_prazo,
            'SITUAÇÃO DOCUMENTAL PRAZO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.arte_prazo,
            'ARTE, CULTURA, ESPORTE E LAZER PRAZO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.aspecto_prazo,
            'ASPECTOS SOCIOFAMILIARES PRAZO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.processual_prazo, 'PROCESSUAL PRAZO ')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.makeHTML(historico.new_values.saude_prazo, 'SAÚDE PRAZO '))}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.educacao_prazo, 'EDUCAÇÃO PRAZO ')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.profissionalizacao_prazo,
            'PROFISSIONALIZAÇÃO PRAZO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.aspecto_prazo,
            'ASPECTOS SOCIOFAMILIARES PRAZO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.condicao_prazo,
            'CONDIÇÕES SOCIOECONÔMICAS PRAZO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.vulnerabildiade_prazo,
            'VULNERABILIDADE SOCIOFAMILIARES PRAZO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.desligamento_prazo,
            'PREPARAÇÃO PARA DESLIGAMENTO PRAZO '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(historico.new_values.data_avaliacao, 'DATA AVALIAÇÃO ')
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.orientador_social_responsavel_nome,
            'ORIENTADOR SOCIAL RESPONSÁVEl '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.acomp_creas_unidade_nome,
            'LOCAL CUMPRIMENTO DA MEDIDA '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(
          _vm.makeHTML(
            historico.new_values.acomp_creas_unidade_nome,
            'LOCAL CUMPRIMENTO DA MEDIDA '
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"row"},[(historico.new_values.vulnerabilidades)?_c('div',{staticClass:"col-12 py-1"},[_c('b',[_vm._v("VULNERABILIDADE(S):")]),_vm._v(" "),_vm._l((historico.new_values
              .vulnerabilidades),function(vulnerabilidade,index){return _c('b',{key:vulnerabilidade.id,staticClass:"mr-2 badge badge-default"},[_vm._v("\n            "+_vm._s(_vm.verificarValueArray(vulnerabilidade, _vm.vulnerabilidades_tipos))+"\n          ")])})],2):_vm._e(),_vm._v(" "),(historico.new_values.aspectos_pessoais_outros)?_c('div',{staticClass:"col-12 py-1"},[_c('b',[_vm._v(" OUTROS ASPECTOS PESSOAIS:")]),_vm._v(" "),_vm._l((JSON.parse(
              historico.new_values.aspectos_pessoais_outros
            )),function(aspectos,index){return _c('b',{key:aspectos,staticClass:"mr-2 badge badge-default"},[_vm._v("\n            "+_vm._s(aspectos)+"\n          ")])})],2):_vm._e(),_vm._v(" "),(
            historico.new_values.denuncias &&
            historico.new_values.denuncias.length > 0
          )?_c('div',{staticClass:"col-12 py-1"},[_c('b',[_vm._v("DENÚNCIAS:")]),_vm._v(" "),_vm._l((historico.new_values.denuncias),function(denuncia,index){return _c('b',{key:index,staticClass:"mr-2 badge badge-default"},[(denuncia)?_c('router-link',{staticClass:"btn btn-sm btn-light py-0 px-1 my-1",attrs:{"to":`/dashboard/denuncias/edit/${denuncia.id}`}},[_vm._v("\n              "+_vm._s(denuncia.protocolo)+"\n            ")]):_vm._e()],1)})],2):_vm._e()])]):_vm._e()])}),_vm._v(" "),(_vm.historicos.length <= 0)?_c('h2',{staticClass:"text-warning"},[_c('span',{staticClass:"mdi mdi-clipboard-search-outline"}),_vm._v(" Por enquanto não\n    temos nenhuma atualização.\n  ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }